<template>
  <article class="select">
    <div class="select-block">
      <div class="title">500强之选</div>
      <div class="select-list">
        <div class="list" v-for="(item, index) in selectList" :key="index">
          <div class="bj"><img :src="item.bj" alt="背景图" /></div>
          <img class="icon" :src="item.icon" alt="icon" />
          <div class="desc">{{ item.desc }}</div>
          <div class="tip">{{ item.tip }}</div>
        </div>
      </div>
      <div class="red-title">支持<span>多个业务场景</span>的全栈解决方案，以更多的选择满足不同的业务需求</div>
      <div class="icons-list">
        <div class="list" v-for="item in iconList" :key="item.title">
          <img :src="item.icon" :alt="item.title" />
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data() {
    return {
      selectList: [
        {
          bj: require('@/assets/images/real-estate/select-bj-1.jpg'),
          icon: require('@/assets/images/real-estate/select-icon-1.png'),
          desc: '恒大集团通过e签宝建设电子签章一体化管控平台，在集团内部全场景接入统一的电子签章平台。',
          tip: '人事管理｜物业管理｜商品房交易｜房屋租赁｜项目管理',
        },
        {
          bj: require('@/assets/images/real-estate/select-bj-2.jpg'),
          icon: require('@/assets/images/real-estate/select-icon-2.png'),
          desc: '金科地产一期供应商签署招标合同场景，由房地产企业端发起合同签署，供应商接收电子合同完成签署。',
          tip: '招采业务场景',
        },
      ],
      iconList: [
        { icon: require('@/assets/images/real-estate/select-icons-1.svg'), desc: '营销认购' },
        { icon: require('@/assets/images/real-estate/select-icons-2.svg'), desc: '企业采购' },
        { icon: require('@/assets/images/real-estate/select-icons-3.svg'), desc: '人事管理' },
        { icon: require('@/assets/images/real-estate/select-icons-4.svg'), desc: '房屋租赁' },
        { icon: require('@/assets/images/real-estate/select-icons-5.svg'), desc: '物业管理' },
      ],
    }
  },
}
</script>

<style lang="less" scoped>
.select {
  width: 100%;
  background: #f7f7f7;
  padding: 80px 0;
  &-block {
    width: 1180px;
    margin: 0 auto;
  }
  .title {
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 40px;
    text-align: center;
  }
  &-list {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;

    .list {
      width: 580px;
      height: 300px;
      padding: 0 44px;
      position: relative;
      z-index: 1;

      &:hover {
        .bj img {
          transform: scale(1.2);
        }
      }
    }

    .bj {
      width: 580px;
      height: 300px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -11;
      overflow: hidden;
      img {
        width: 580px;
        transition: all 0.3s ease-out;
      }
    }

    .icon {
      height: 42px;
      width: auto;
      margin-top: 40px;
    }

    .desc {
      margin-top: 20px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 28px;
    }

    .tip {
      margin-top: 74px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 28px;
    }
  }

  .red-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    margin-top: 50px;
    text-align: center;
    span {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #d30000;
    }
  }

  .icons-list {
    margin-top: 30px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    .list {
      width: 220px;
      height: 120px;
      text-align: center;
      padding: 16px 0;
    }
    img {
      width: 48px;
      margin: 0 auto;
    }
    .desc {
      margin-top: 16px;
    }
  }
}
</style>
